import React, { useRef, useEffect, useContext, useState } from "react";
import { AppContext, ValueContext } from "../../context/createContext";
import { createStars, valueUpdate } from "./stars";
import { Shuttle } from "./shuttle/Shuttle";
import { Explosion } from "./explosion/explosion";
// import { Station } from "./station/Station"
import { Container } from "pixi.js";
import { resizeHandler } from "./helpers";
import { MainBoard } from "./style";
import { createApp } from "./createApp";
import { pixiAnimationsFlow } from "./pixiAnimationsFlow";
// import { planetsFlow } from "./flow/planetsFlow";
import { Astronaut } from "./astronaut/astronaut";
import { ShuttleEnd } from "./shuttle/ShuttleEnd";
// import { initializePlanets } from "../pixiBoard/flow/planetsArray";
import { Airdrop } from "./airdrop/airdrop";
import { BlackHole } from "./blackHole/BlackHole";

const {
  // startLaunchAnimation,
  // setShuttleContainer,
  // removeShuttle,
  // initShuttle,
  getShuttleResourses,
} = new Shuttle();

// const { stationLaunchAnimation, stationAfterLounchAnimation, removeStation } =
//   new Station()

const { startAirdop, setContainerForAirdrop } = new Airdrop();
const {
  startBlackHole,
  setContainerForBlackHole,
  hideBlackHole,
  getBlackHoleResourses,
} = new BlackHole();

const {
  startExplosion,
  setContainerForExposion,
  getExplosionResourses,
  initExplosion,
} = new Explosion();

const {
  shuttleEngineStartAnimation,
  setShuttleEndContainer,
  removeShuttleEnd,
  initShuttleEnd,
  fadeOutInBlackHole,
  addShuttle,
} = new ShuttleEnd();

let app: any = null;
const container = new Container();
// const containerForBlackHole = new Container()

export function getResourses() {
  let resourses: any = [];
  resourses = resourses.concat(getShuttleResourses());
  resourses = resourses.concat(getExplosionResourses());
  resourses = resourses.concat(getBlackHoleResourses());
  return resourses;
}

export function initializeGraphics() {
  // initShuttle()
  initShuttleEnd();
  initExplosion();
  // initializePlanets(container);
}

export function StarBackground({
  isLoading,
  setIsJackpot,
  isJackpot,
  jackpotPopup,
}: any) {
  const {
    // roundupdate,
    isError,
    errorText,
    roundUserUpdate,
    jackpotState,
    airdrop,
  } = useContext(AppContext);

  const { roundupdate } = useContext(ValueContext);

  const { value, state } = roundupdate;
  const ref = useRef<any>(null);
  const isErrorRef = useRef<any>(null);

  useEffect(() => {
    isErrorRef.current = isError;
  }, [isError]);

  useEffect(() => {
    if (ref.current?.children.length < 1 && !app) {
      app = createApp();
    }
    if (ref.current?.children.length === 0 && app) {
      ref.current.appendChild(app.view);
      createStars(app.stage, app.ticker, app);
      app.stage.addChild(container);
      // setShuttleContainer(container)
      setContainerForExposion(container);
      setShuttleEndContainer(container);
      setContainerForAirdrop(container);
      setContainerForBlackHole(container, app);
    }
  }, []);

  useEffect(() => {
    function removeContainer() {
      if (isJackpot && document.visibilityState === "visible") {
        return;
      }
      if (document.visibilityState === "visible" && !isJackpot) {
        if (errorText) {
          container.alpha = 0;
        }
        if (state === 1) {
          removeShuttleEnd();
          addShuttle();
        }
        if (state === 2) {
          removeShuttleEnd();
          addShuttle();
          shuttleEngineStartAnimation();
        }
        if (state === 3) {
          setTimeout(() => {
            removeShuttleEnd();
          }, 100);
          startExplosion();
        }
      }
      // if (state !== 2 && !isJackpot) {
      //   removeShuttleEnd();
      //   console.log('remove shuttle')
      // }
    }
    window.addEventListener("visibilitychange", removeContainer);

    return () =>
      window.removeEventListener("visibilitychange", removeContainer);
  }, [state, errorText, value, isJackpot, jackpotState.state]);

  useEffect(() => {
    isLoading || errorText ? (container.alpha = 0) : (container.alpha = 1);
  }, [isLoading, errorText]);

  useEffect(() => {
    if (!isLoading) valueUpdate(value, state, errorText, jackpotState.state);
  }, [value, state, errorText, jackpotState.state]);

  // useEffect(() => {
  //   if (!isLoading)
  //     setTimeout(() => {
  //       planetsFlow(state, value, isJackpot, jackpotPopup);
  //     }, 0);
  // }, [state, value, isLoading, isJackpot, jackpotPopup]);

  useEffect(() => {
    if (airdrop.type) {
      startAirdop();
    }
  }, [airdrop]);

  useEffect(() => {
    if (
      jackpotState.state === "initJackpot" ||
      jackpotState.state === "roundStarted"
    ) {
      setIsJackpot(true);
    }
    if (jackpotState.state === "initBlackHole") {
      startBlackHole();
      setTimeout(() => {
        fadeOutInBlackHole();
        hideBlackHole();
      }, 5000);
    }
  }, [jackpotState.state]);

  useEffect(() => {
    if (!isLoading) {
      pixiAnimationsFlow(
        isLoading, // shuttle, station, explosion
        state,
        addShuttle,
        // startLaunchAnimation,
        shuttleEngineStartAnimation,
        removeShuttleEnd,
        app.ticker,
        container,
        // removeShuttle,
        startExplosion,
        // value,
        errorText,
        isJackpot,
        jackpotPopup
      );
    }
  }, [state, isLoading, errorText, isJackpot, jackpotPopup]);

  useEffect(() => {
    if (roundUserUpdate.state === 5 && !isLoading && !isError && !isJackpot) {
      const { astronautFallAnimation } = new Astronaut();
      astronautFallAnimation(app.ticker, container);
    }
  }, [roundUserUpdate, isError, isLoading, isJackpot]);

  useEffect(() => {
    window.addEventListener("resize", function () {
      resizeHandler(app, container, isLoading, isJackpot);
    });
    return () => window.removeEventListener("resize", resizeHandler);
  }, [isLoading, isJackpot]);

  useEffect(() => {
    resizeHandler(app, container, isLoading, isJackpot);
  }, [isLoading, isJackpot]);

  useEffect(() => {
    resizeHandler(app, container, isLoading, isJackpot);
  }, [document.body.clientWidth, document.body.clientHeight]);

  return <MainBoard ref={ref} isLoading={isLoading} />;
}
